// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"106":"music","162":"films","337":"Contact","348":"food","819":"web"}[chunkId] + "." + {"106":"e90f1211","162":"75452937","337":"a73959a8","348":"c1526343","819":"58d2761f"}[chunkId] + ".css";
};